<template>
  <JurnalList jenisJurnal="10" :title="title"  :routeInput="input" :routeEdit="edit" />
</template>

<script>
import JurnalList from '@/views/jurnal/JurnalList.vue';

export default {
    components: {
        JurnalList
    },
    data:() => ({
       title : 'Jurnal Mutasi Kas Bank',
       input : 'jmkbinput',
       edit : 'jmkbedit'
    }),
    methods: {
       
    }
}
</script>


<style>

</style>